@if (pager.pages && pager.pages.length) {
  <ul class="flex items-center justify-center list-none mb-16 px-10">
    @if (currentPage > 1) {
      <li class="mr-2.5">
        <a class="flex items-center cursor-pointer"
           [routerLink]="pager.prevPage.routerLink"
           [queryParams]="pager.prevPage.queryParams"
           appIndexedLink
           [indexedLink]="baseRouterLink"
           [targetUrl]="pager.prevPage.routerLink"
           [targetParams]="pager.prevPage.queryParams"
        >
          <span class="block leading-0 md:hidden">
            <app-ui-icon name="chevron_back" size="sm" color="var(--duck-blue-2)"></app-ui-icon>
          </span>
          <span class="hidden md:flex items-center">
            <app-ui-icon name="chevron_back" size="sm" color="var(--duck-blue-2)"></app-ui-icon>
            @if (displayLabels) {
              <span class="ml-1">Föregående</span>
            }
          </span>
        </a>
      </li>
    }

    <ul class="flex justify-center items-center m-0 p-0 select-none">
      @for (page of visiblePages; track page.pageNumber; let first = $first, last = $last) {
        @if (showLastEllipsis && last) {
          <li class="cursor-pointer w-10 h-10 leading-10 text-center select-none mx-2.5 text-[var(--duck-blue-2)]">
            <span>&hellip;</span>
          </li>
        }
        <li
          class="flex justify-center items-center w-10 h-10 rounded-full mr-2.5 last:mr-0 {{currentPage === page.pageNumber ? 'bg-[var(--duck-blue-1)]' : ''}}">
          @if (!page.link.queryParams || Object.keys(page.link.queryParams).length === 0) {
            <a
              [routerLink]="page.link.routerLink"
              [queryParams]="page.link.queryParams"
              class="no-underline {{currentPage === page.pageNumber ? 'text-[var(--duck-blue-9)] font-bold' : 'text-[var(--duck-blue-2)]'}}"
            >
              {{ page.pageNumber }}
            </a>
          } @else {
            <a
              [routerLink]="page.link.routerLink"
              [queryParams]="page.link.queryParams"
              appIndexedLink
              [indexedLink]="baseRouterLink"
              [targetUrl]="page.link.routerLink"
              [targetParams]="page.link.queryParams"
              class="no-underline cursor-pointer {{currentPage === page.pageNumber ? 'text-[var(--duck-blue-9)] font-bold' : 'text-[var(--duck-blue-2)]'}}"
            >
              {{ page.pageNumber }}
            </a>
          }
        </li>
        @if (showFirstEllipsis && first) {
          <li class="cursor-pointer w-10 h-10 leading-10 text-center select-none mx-2.5 text-[var(--duck-blue-2)]">
            <span>&hellip;</span>
          </li>
        }
      }
    </ul>

    @if (currentPage < pager.totalPages) {
      <li class="ml-2.5">
        <a class="flex items-center cursor-pointer"
           [routerLink]="pager.nextPage.routerLink"
           [queryParams]="pager.nextPage.queryParams"
           appIndexedLink
           [indexedLink]="baseRouterLink"
           [targetUrl]="pager.nextPage.routerLink"
           [targetParams]="pager.nextPage.queryParams">
          <span class="block leading-0 md:hidden">
            <app-ui-icon name="chevron_right" size="sm" color="var(--duck-blue-2)"></app-ui-icon>
          </span>
          <span class="hidden md:flex items-center">
            @if (displayLabels) {
              <span class="mr-1">Nästa</span>
            }
            <app-ui-icon name="chevron_right" size="sm" color="var(--duck-blue-2)"></app-ui-icon>
          </span>
        </a>
      </li>
    }
  </ul>
}
